var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p-background',{attrs:{"background":_vm.background}}),_vm._v(" "),_c('div',{staticClass:"container mx-auto px-md py-xl lg:px-xl"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }